module.exports = __webpack_public_path__ + "static/media/pre_owned_title_ko@3x.2d724e3d.png";